
<div class="main_404_page">
    <section class="error-container">
        <span class="four"><span class="screen-reader-text">4</span></span>
        <span class="zero"><span class="screen-reader-text">0</span></span>
        <span class="four"><span class="screen-reader-text">4</span></span>
    </section>
    <p class="zoom-area"><b>Oops!</b> It looks like you're lost...
        That's a trouble? </p>
  </div>
  